export default {
    'common.auto.connect': '自动连接',
    'common.connect.status': '连接状态',
    'common.client.url': '客户端地址1'
};
